/* mossriver-ga4-custom-events-v2
 * Standard page views and commerce events stay owned by Shopify's Google app.
 * This bridge only makes custom experiment events deliverable to GA4.
 */
(function () {
  'use strict';
  if (window.__mossriverGa4CustomEventsV2) return;
  window.__mossriverGa4CustomEventsV2 = true;
  window.dataLayer = window.dataLayer || [];
  var active = false;

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;
    if (typeof privacy.analyticsProcessingAllowed === 'function') {
      return privacy.analyticsProcessingAllowed();
    }
    if (typeof privacy.userCanBeTracked === 'function') {
      return privacy.userCanBeTracked();
    }
    return true;
  }

  window.gtag = window.gtag || function () {
    if (arguments[0] === 'event' && !active) return;
    window.dataLayer.push(arguments);
  };

  function start() {
    if (active || !analyticsAllowed()) return;
    active = true;
    if (!document.querySelector('script[data-mossriver-ga4-custom-events]')) {
      var tag = document.createElement('script');
      tag.async = true;
      tag.src = 'https://www.googletagmanager.com/gtag/js?id=G-8VWWZKPJQ7';
      tag.setAttribute('data-mossriver-ga4-custom-events', 'v2');
      document.head.appendChild(tag);
    }
    window.gtag('js', new Date());
    window.gtag('config', 'G-8VWWZKPJQ7', {send_page_view: false});
  }

  function loadPrivacyThenStart() {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{name: 'consent-tracking-api', version: '0.1'}],
        function () { start(); }
      );
    } else {
      start();
    }
  }

  document.addEventListener('visitorConsentCollected', start, false);
  document.addEventListener('trackingConsentAccepted', start, false);
    loadPrivacyThenStart();

  function attribution() {
    var q = new URLSearchParams(location.search);
    var saved = {};
    try { saved = JSON.parse(sessionStorage.getItem('mossriver_funnel_context') || '{}'); } catch (e) {}
    var source = q.get('moss_source') || q.get('utm_source') || saved.source || 'direct';
    var campaign = q.get('moss_campaign') || q.get('utm_campaign') || saved.campaign || '';
    var content = q.get('moss_content') || q.get('utm_content') || saved.content || '';
    if (q.get('moss_campaign')) {
      try { sessionStorage.setItem('mossriver_funnel_context', JSON.stringify({source: source, campaign: campaign, content: content})); } catch (e) {}
    }
    return {
      source: source,
      campaign: campaign,
      content: content
    };
  }

  function emit(name, params) {
    if (!active || !analyticsAllowed()) return;
    window.gtag('event', name, Object.assign({transport_type: 'beacon'}, params || {}));
  }

  function emitCommerceEvent(name, params, campaign) {
    emit(name, params);
    var experimentEvents = {
      'exp_20260808_article_pdp': {
        'view_item': 'mossriver_exp_article_pdp_view_item',
        'add_to_cart': 'mossriver_exp_article_pdp_add_to_cart',
        'begin_checkout': 'mossriver_exp_article_pdp_begin_checkout',
        'purchase': 'mossriver_exp_article_pdp_purchase'
      }
    };
    var mapped = experimentEvents[campaign] && experimentEvents[campaign][name];
    if (mapped) emit(mapped, params);
  }

  function installCommerceReadback() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var product = meta && meta.product;
    if (!product || !product.id || window.__mossriverViewItemV2) return;
    window.__mossriverViewItemV2 = true;
    var selected = product.variants && product.variants[0];
    var a = attribution();
    emitCommerceEvent('view_item', {
      currency: (meta.currency || 'USD'),
      value: selected ? Number(selected.price || 0) / 100 : undefined,
      items: [{item_id: String(product.id), item_name: selected ? selected.name : product.handle, item_variant: selected ? String(selected.id) : undefined}],
      moss_source: a.source, moss_campaign: a.campaign, moss_content: a.content
    }, a.campaign);
    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      emitCommerceEvent('add_to_cart', {currency: (meta.currency || 'USD'), moss_source: a.source, moss_campaign: a.campaign, items: [{item_id: String(product.id), item_name: product.handle}]}, a.campaign);
    }, true);
    document.addEventListener('click', function(event) {
      var link = event.target.closest && event.target.closest('a[href*="/checkout"]');
      if (link) emitCommerceEvent('begin_checkout', {currency: (meta.currency || 'USD'), moss_source: a.source, moss_campaign: a.campaign, items: [{item_id: String(product.id), item_name: product.handle}]}, a.campaign);
    }, true);
  }

  function installCheckoutReadback() {
    if (window.__mossriverCheckoutReadbackV2) return;
    window.__mossriverCheckoutReadbackV2 = true;
    var a = attribution();
    function checkoutPayload() {
      return {moss_source: a.source, moss_campaign: a.campaign, moss_content: a.content};
    }
    document.addEventListener('click', function(event) {
      var target = event.target.closest && event.target.closest('a,button');
      if (target && (/\/checkout/.test(target.href || '') || /check\s*out/i.test(target.textContent || ''))) emitCommerceEvent('begin_checkout', checkoutPayload(), a.campaign);
    }, true);
    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (form && /\/checkout/.test(form.action || '')) emitCommerceEvent('begin_checkout', checkoutPayload(), a.campaign);
    }, true);
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(installCommerceReadback, 0);
    setTimeout(installCheckoutReadback, 0);
  });
}());
